import React from 'react'
import {
  Box,
  Typography,
  Paper,
  useMediaQuery,
  useTheme
} from '@mui/material'
import { getStepperContainerHeight } from '../../../utils/helpers'

interface PositionsStepLayoutProps {
  children: React.ReactNode
  error?: string
  actionButtons: React.ReactNode
}

export const PositionsStepLayout: React.FC<PositionsStepLayoutProps> = ({
  children,
  error,
  actionButtons
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  // Offset de 170px: 120px base + 48px del BackButton del StepperShell
  const containerHeight = getStepperContainerHeight(170)

  return (
    <Box
      style={{
        height: containerHeight,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}
    >
      <Box
        p={isMobile ? 1.5 : 2}
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto'
        }}
      >
        <Box
          display="flex"
          justifyContent="center"
          style={{ flex: 1 }}
        >
          <Box
            style={{
              width: '100%',
              maxWidth: isMobile ? '100%' : '600px',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            {children}
          </Box>
        </Box>

        {error && (
          <Box mt={3}>
            <Paper
              style={{
                backgroundColor: theme.palette.error.light + '20',
                border: `1px solid ${theme.palette.error.main}`,
                padding: '12px 16px',
                borderRadius: '4px'
              }}
            >
              <Typography
                variant="body2"
                style={{ color: theme.palette.error.dark }}
              >
                {error}
              </Typography>
            </Paper>
          </Box>
        )}
      </Box>

      {/* Action Buttons - Fixed at bottom */}
      <Box
        p={isMobile ? 1.5 : 2}
        style={{
          backgroundColor: theme.palette.background.paper,
          borderTop: `1px solid ${theme.palette.divider}`,
          position: 'sticky',
          bottom: 0
        }}
      >
        {actionButtons}
      </Box>
    </Box>
  )
}
